<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <search-filter
          :enableLeft="false"
          :enableDate="false"
          @search="params.storedCardActivityName = $event"
          placeholder="请输入名称"
          :enableFilter="false"
          :enableSearch="true"
          :searchIcon="false"
        ></search-filter>
      </div>

      <div class="smain">
        <div class="slist">
          <div
            class="sitem van-hairline--bottom"
            v-for="item in listAll"
            :key="item.id"
            @click="clickHandler(item)"
          >
            <div class="l sicon">
              <side-icon-select :checked="ids.includes(item.id)" />
            </div>
            <div class="r">
              <div class="rln1">{{ item.activityName }}</div>
              <div class="rln2">
                <div class="txt van-ellipsis" v-html="getRuleText(item)"></div>
                <div class="txbtn" @click.stop="showStoredCard(item)">查看</div>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="没有找到储值卡活动~"
          image-size="128"
          style="margin-top: 20vh"
        ></van-empty>
      </div>

      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          :isAll="checkAll"
          key_txt="activityName"
          @clickAllBtn="checkAll = !checkAll"
        ></select-Base>
      </side-foot>

      <template>
        <van-action-sheet v-model="as" :round="false" get-container="body">
          <div class="as1wrap">
            <div class="head">
              <div class="til">{{ asCard.activityName }}</div>
            </div>
            <div class="as1body">
              <div class="line">
                <div class="l1">
                  <div class="label">优惠规则</div>
                  <div class="content" v-html="getRuleText(asCard)"></div>
                </div>
                <div class="l1">
                  <div class="label">最低起充金额</div>
                  <div class="content">{{ asCard.lowRechargeMoney | formatNumber }}</div>
                </div>
                <div class="l1">
                  <div class="label">备注</div>
                  <div class="content">{{ asCard.remark }}</div>
                </div>
              </div>
            </div>
          </div>
        </van-action-sheet>
      </template>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-card',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '选择储值卡活动',
      // 是否正在加载数据
      loading: true,
      // 储值卡活动弹窗
      as: false,
      asCard: {},
      params: {
        storedCardActivityName: '',
        saleStatus: 1 // 查询储值卡活动添加入参saleStatus 销售状态 0:停售 1:启售
      },
      // 配置项
      config: {
        // 是否单选功能
        radio: false,
      },
    };
  },
  methods: {
    async showStoredCard(item) {
      this.asCard = item;
      this.as = true;
    },
    getRuleText(item) {
      // promoType 优惠规则；1满送优惠，2阶梯优惠	
      let txt = '';
      if (item && item.storedCardActivityPromoDetails && item.storedCardActivityPromoDetails.length>0) {
        item.storedCardActivityPromoDetails.forEach(it=> {
          txt += `${item.promoType==1?'充值每满':'充值达'}${app.tool.formatNumber(it.principalMoney)}赠送${app.tool.formatNumber(it.giveMoney)}${item.storedCardActivityPromoDetails.length > 1 ? '<br/>' : ''}`
        });
      }
      return txt;
    },
    async getData() {
      this.loading = true;
      this.showLoading();
      let res = await this.$api.getActivityPromoDetails(this.params);
      this.loading = false;
      vant.Toast.clear();
      this.listAll = res.data;
    },
  },
  watch: {
    'params.storedCardActivityName': {
      handler() {
        this.getData();
      }
    }
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        display: flex;
        padding: calc(var(--gap) * 12) 0;
        .l.sicon {
          margin-right: calc(var(--gap) * 16);
          padding-top: calc(var(--gap) * 2);
        }
        .r {
          flex: 1;
          overflow: hidden;
          .rln1 {
            color: var(--g8);
            font-size: var(--fs-md);
            line-height: var(--lh-md);
            font-weight: var(--bold);
          }
          .rln2 {
            display: flex;
            align-items: center;
            margin-top: calc(var(--gap) * 4);
            color: var(--g6);
            font-size: var(--fs-sm);
            line-height: var(--lh-sm);
            .txt {
              display: inline-block;
              max-width: calc(100% - var(--gap) * 30);
            }
            .txbtn {
              margin-left: calc(var(--gap) * 4);
              display: inline-block;
              color: var(--tlc);
            }
          }
        }
      }
    }
  }
}

.as1wrap {
  .head {
    // height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    text-align: center;
    .clearbtn {
      position: absolute;
      right: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .as1body {
    min-height: 200px;
    max-height: 70vh;
    overflow: auto;
    .line {
      margin: 0 calc(var(--gap) * 16);
      padding: calc(var(--gap) * 8) 0;
      .l1 {
        padding: calc(var(--gap) * 8) 0;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g8);
        display: flex;
        .label {
          margin-right: calc(var(--gap) * 22);
          width: calc(var(--gap) * 85);
          color: var(--g7);
        }
        .content {
          flex: 1;
        }
      }
    }
  }
}
</style>